import { SignIn } from "@clerk/clerk-react";
import { Box } from "@mui/material";

const Login = () => {
	return (
		<Box
			sx={{
				width: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				marginTop: 10,
			}}
		>
			<SignIn
				redirectUrl="/internal"
				appearance={{
					elements: {
						footerAction: { display: "none" },
					},
				}}
			/>
		</Box>
	);
};

export default Login;
